import { useCallback } from "react";
import {
  logBrowseChemoRegimenSortUpdated,
  logBrowseChemoRegimenFilterUpdated,
  logBrowseChemoRegimenTopicClicked,
} from "../../../util/analytics";

export const useTelemetry = ({ sharedTelemetryData }) => {
  const onRegimenClick = useCallback(
    (regimen) => {
      logBrowseChemoRegimenTopicClicked({
        title: regimen.regimenTitle,
        pubType: sharedTelemetryData.pubType,
        categoryId: sharedTelemetryData.categoryId,
        affordance: sharedTelemetryData.affordance,
      });
    },
    [sharedTelemetryData]
  );

  return {
    onRegimenClick,
    logSortUpdated: logBrowseChemoRegimenSortUpdated,
    logFilterUpdated: logBrowseChemoRegimenFilterUpdated,
  };
};
